import {Component, OnInit, Input, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { GedModel } from '../ged.model';
import { ResponseWorkflowService } from 'src/app/core-api/services/responses/response-workflow.service';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';

@Component({
    selector: 'abw-ged-result',
    templateUrl: './ged-result.component.html',
    styleUrls: ['./ged-result.component.scss']
})
export class GedResultComponent implements OnInit {
	@Input() model: GedModel;
    @Input() value: { SCANNED_DOCUMENT: any, RESULTS: any[] };
    loading = false;
    documentScanned: string = null;
    errorMessage: any = null;

    constructor(
        private _responseWorkflowService: ResponseWorkflowService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.value && !!changes.value.currentValue && !!changes.value.currentValue.SCANNED_DOCUMENT && this.documentScanned == null) {
            this.doGetFileContent(this.value.SCANNED_DOCUMENT);
        }
    }

    private doGetFileContent(_filename: string) {
        this.loading = true; 
        this._responseWorkflowService.doReadResponseWorkflowFile(CODE_WORKFLOW_COMPONENT.GED, _filename).then(_fileContent => {
            this.documentScanned = "data:image/png;base64," + _fileContent;
            this.loading = false;
            this._cdf.detectChanges();
        }, (err) => {
            this.errorMessage = err;
            this.loading = false;
        });
    }
}